import { useMemo, useState } from 'react'
import {
  getLocalizedChanges,
  RELEASE_NOTES,
} from './releaseNotes'

const INITIAL_VISIBLE_RELEASE_NOTES = 5
const RELEASE_NOTES_BATCH_SIZE = 5

export const useReleaseNotes = (language: string) => {
  const [visibleCount, setVisibleCount] = useState(INITIAL_VISIBLE_RELEASE_NOTES)

  const localizedReleaseNotes = useMemo(() => (
    RELEASE_NOTES.filter(note => (
      Object.values(getLocalizedChanges(note.changes, language)).some(items => items.length > 0)
    ))
  ), [language])

  const visibleReleaseNotes = useMemo(() => (
    localizedReleaseNotes.slice(0, visibleCount)
  ), [localizedReleaseNotes, visibleCount])

  return {
    latestRelease: RELEASE_NOTES[0],
    hasNoReleaseNotes: localizedReleaseNotes.length === 0,
    visibleReleaseNotes,
    hasMoreReleaseNotes: visibleCount < localizedReleaseNotes.length,
    loadMore: () => setVisibleCount(count => count + RELEASE_NOTES_BATCH_SIZE)
  }
}
